import { render, staticRenderFns } from "./DataAnalysisDataSourcesListComponent.vue?vue&type=template&id=940b6dc8"
import script from "./DataAnalysisDataSourcesListComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDataSourcesListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports